module.exports = __webpack_public_path__ + "static/media/cluid-housing.648e8843.png";